import React from 'react';
import Button from '../../../../shared/button';

interface ITabs {
    tabs: any[];
    activeTab: string;
    onClickTab: (value: any) => void;
}

const Tabs = ({
    tabs,
    activeTab,
    onClickTab

}: ITabs) => {
    return (
        <div className='my-8'>
            <div className='mt-2 mb-8 sm:mb-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-2 md:gap-4'>
                {tabs && tabs?.length > 0 && tabs?.map((tab, index) => {
                    let buttonClassName = 'btn-categories'
                    if (activeTab === tab?.name) buttonClassName = 'btn-categories';
                    else buttonClassName = 'btn-noactive-categories border';
                    return (
                        <Button
                            key={index}
                            label={tab?.name}
                            dataQa={'tabs-name'}
                            className={`${buttonClassName} !min-w-[70px]`}
                            onClickButton={() => onClickTab(tab)}
                        />
                    )
                })}
            </div>
        </div>
    )
}
export default Tabs
